/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';

import {deferMarkForCheck} from '../util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-route-two-panel-layout',
  template: `
    <div class="row">
      <ui-view class="col-sm-6" *ngIf="!panelFull" name="leftPanel"></ui-view>
      <ui-view class="col-sm-8 col-sm-offset-2" *ngIf="panelFull" name="leftPanelPartA"></ui-view>
      <ui-view class="col-sm-6" *ngIf="!panelFull" name="rightPanel"></ui-view>
    </div>
  `
})
export class RouteTwoPanelLayoutComponent implements OnInit {
  /**
   * Template-bound panel mode. May lag the `full` input by one macrotask so
   * *ngIf does not flip mid-CD (NG0100) when a child redirects with full:true
   * or modelComms.commMade updates the layout.
   */
  panelFull = false;

  @Input() modelComms: any;

  private fullInputSeen = false;

  constructor(private cdr: ChangeDetectorRef) {
  }

  @Input()
  set full(value: boolean) {
    this.applyFull(!!value);
  }

  get full(): boolean {
    return this.panelFull;
  }

  ngOnInit(): void {
    if (this.modelComms) {
      this.modelComms.addSubscriber((data: any, type: string) => {
        if (type === 'commMade' && typeof data?.full === 'boolean') {
          this.applyFull(data.full);
        }
      });
    }
  }

  private applyFull(next: boolean): void {
    if (!this.fullInputSeen) {
      this.fullInputSeen = true;
      this.panelFull = next;
      return;
    }
    if (next === this.panelFull) {
      return;
    }
    deferMarkForCheck(this.cdr, () => {
      this.panelFull = next;
    });
  }
}

@Component({
  standalone: false,
  selector: 'adn-route-two-panel-bottom-layout',
  template: `
    <div class="row">
      <ui-view class="col-sm-6" name="leftPanel"></ui-view>
      <ui-view class="col-sm-6" name="rightPanel"></ui-view>
    </div>
    <div class="row" style="margin-top: 15px">
      <ui-view class="col-sm-12" name="bottomPanel"></ui-view>
    </div>
  `
})
export class RouteTwoPanelBottomLayoutComponent {
}
